import type { UserManagementError } from '~/schema/public';

const useWalletErrors = () => {
  const hasSMS2FAErrors = (error: UserManagementError) =>
    error.message?.includes('SMS_2FA');

  const hasOtpErrors = (error: UserManagementError) => {
    const isMessageOtp = error.message?.includes('OTP');
    const isValueOtp = error.params?.[0]?.value?.includes('otp');
    if (isMessageOtp || isValueOtp) {
      return true;
    }
    return false;
  };

  const hasAgeLimitErrors = (error: UserManagementError) => {
    const isValueDateOfBirth =
      error.params?.[0]?.value?.includes('dateOfBirth');
    if (isValueDateOfBirth) {
      return { error: true, message: `errors.${error.message}` };
    }
    return { error: false, message: '' };
  };

  return { hasSMS2FAErrors, hasOtpErrors, hasAgeLimitErrors };
};

export default useWalletErrors;
